import {
  ContentList,
  CONTENT_TYPES,
} from '@hivebrite/design-system/ContentList';

import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import type {
  Category,
  DiscussionCard,
} from 'hb-react/frontoffice/apps/Forum/types';

export interface WidgetSideProps {
  category: Category;
  discussions: DiscussionCard[];
}

const displayFields = { author: true, content: true, group: true };

const WidgetSide = ({ category, discussions }: WidgetSideProps) => {
  const { configUrls } = useForumContext();

  const data = discussions.map(
    // Remove comments & likes since they are not used in the ContentList
    ({
      id,
      title,
      user,
      comments,
      likes,
      content,
      stripped_content: strippedContent,
      ...rest
    }) => ({
      contentType: CONTENT_TYPES.FORUM,
      hasUncroppedName: true,
      name: title,
      path: configUrls.discussionUrl(id),
      author: {
        ...user,
        photoThumbUrl: user.photo_thumb_url,
        path: Routes.user_path(user.id),
      },
      content: strippedContent,
      ...rest,
    }),
  );

  return (
    <ContentList
      listTitle={category.name}
      data={data}
      displayFields={displayFields}
    />
  );
};

export default WidgetSide;
